import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-teal-900 text-cream-200 py-12 text-center" data-id="element-31">
        <div className="max-w-7xl mx-auto px-4" data-id="element-32">
          <p className="font-serif text-2xl mb-4 text-cream-50" data-id="element-33">
            The Peri‑Belly Protocol
          </p>
          <p className="text-sm opacity-60 mb-6" data-id="element-34">
            © {new Date().getFullYear()} The Peri‑Belly Protocol. All rights
            reserved.
            <br data-id="element-35" />
            This product is for informational purposes only and does not
            constitute medical advice.
          </p>

          <div className="flex items-center justify-center gap-6 text-sm" data-id="element-36">
            <button onClick={() => setShowPrivacy(true)} className="text-cream-200/70 hover:text-gold-500 transition-colors underline underline-offset-4 decoration-cream-200/30 hover:decoration-gold-500" data-id="element-37">
              Privacy Policy
            </button>
            <span className="text-cream-200/30" data-id="element-38">·</span>
            <button onClick={() => setShowTerms(true)} className="text-cream-200/70 hover:text-gold-500 transition-colors underline underline-offset-4 decoration-cream-200/30 hover:decoration-gold-500" data-id="element-39">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-40">
        <p className="text-charcoal-800/60 text-sm italic" data-id="element-41">
          Last updated: February 2026
        </p>

        <h3 className="font-serif text-lg text-teal-900 mt-2" data-id="element-42">
          1. Information We Collect
        </h3>
        <p data-id="element-43">
          When you purchase The Peri‑Belly Protocol, we collect only the
          information necessary to process your order: your name, email address,
          and payment details. Payment is handled securely by our third‑party
          processor (Stripe); we never store your full credit card number.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-44">
          2. How We Use Your Information
        </h3>
        <p data-id="element-45">
          We use your email address solely to deliver your purchase and send the
          optional follow‑up email sequence described at checkout. We do not
          sell, rent, or share your personal information with third parties for
          marketing purposes.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-46">
          3. Cookies &amp; Analytics
        </h3>
        <p data-id="element-47">
          This site may use basic analytics (e.g., page views) to understand how
          visitors interact with the page. We do not use tracking cookies for
          advertising. You can disable cookies in your browser settings at any
          time.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-48">4. Data Retention</h3>
        <p data-id="element-49">
          We retain your email and purchase record for as long as needed to
          provide customer support and comply with legal obligations. You may
          request deletion of your data at any time by emailing us.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-50">5. Your Rights</h3>
        <p data-id="element-51">
          You have the right to access, correct, or delete your personal data.
          If you wish to unsubscribe from emails, you can do so via the
          unsubscribe link in any email we send.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-52">
          6. Changes to This Policy
        </h3>
        <p data-id="element-53">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected on this page with an updated revision date.
        </p>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-54">
        <p className="text-charcoal-800/60 text-sm italic" data-id="element-55">
          Last updated: February 2026
        </p>

        <h3 className="font-serif text-lg text-teal-900 mt-2" data-id="element-56">
          1. Product Description
        </h3>
        <p data-id="element-57">
          The Peri‑Belly Protocol is a digital information product (PDF ebook
          with accompanying checklists and trackers). It is designed for
          educational purposes and provides general wellness guidance for women
          ages 35–55.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-58">
          2. Not Medical Advice
        </h3>
        <p data-id="element-59">
          This product is <strong data-id="element-60">not</strong> a substitute for professional
          medical advice, diagnosis, or treatment. Always consult your physician
          or qualified health provider before starting any new diet, exercise,
          or wellness program—especially if you have existing health conditions
          or are on medication.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-61">
          3. Digital Delivery
        </h3>
        <p data-id="element-62">
          Upon purchase, you will receive immediate access to download the
          product via email. Due to the digital nature of this product, all
          sales are final. If you experience any issues with your download,
          please reach out and we will resolve it promptly.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-63">
          4. Intellectual Property
        </h3>
        <p data-id="element-64">
          All content within The Peri‑Belly Protocol—including text, graphics,
          and design—is protected by copyright. You may not reproduce,
          distribute, or resell any part of this product without written
          permission.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-65">
          5. Results Disclaimer
        </h3>
        <p data-id="element-66">
          Individual results vary. The information provided is based on general
          wellness principles and is not a guarantee of specific outcomes. Your
          results depend on many factors including consistency, individual
          health, and lifestyle.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-67">
          6. Limitation of Liability
        </h3>
        <p data-id="element-68">
          To the fullest extent permitted by law, we shall not be liable for any
          indirect, incidental, or consequential damages arising from the use of
          this product. Our total liability shall not exceed the purchase price
          paid.
        </p>

        <h3 className="font-serif text-lg text-teal-900" data-id="element-69">7. Governing Law</h3>
        <p data-id="element-70">
          These terms shall be governed by and construed in accordance with
          applicable law, without regard to conflict of law provisions.
        </p>
      </Modal>
    </>;
}